/* START_MODULE client_entrypoint */
/* START_CONTRACT
PURPOSE: Hydrate or mount the localized React application and load its ordered style layers.
OPERATIONAL_CONTEXT: Browser entrypoint generated by Vite and hydrated from prerendered HTML when possible.
PUBLIC_SURFACE: Side-effectful client bootstrap.
KEYWORDS: react, hydration, styles, entrypoint
COMPLEXITY: 1
END_CONTRACT */

import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "katex/dist/katex.min.css";
import "./styles.css";
import "./timeline.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("React root element was not found");
}

const application = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

if (root.hasChildNodes() && window.location.search === "") {
  hydrateRoot(root, application);
} else {
  root.replaceChildren();
  createRoot(root).render(application);
}

/* END_MODULE client_entrypoint */
